module.exports = __webpack_public_path__ + "static/media/08A.8a165366.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/robots/08A.png
// module id = 256
// module chunks = 0